import {Component, HostListener, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";
import {SuccessStoryComponent} from "../component/success-story/success-story.component";
import {PerformanceSectionComponent} from "../component/performance-section/performance-section.component";
import {CommonModule} from "@angular/common";
import {Pages} from "../../dto/Pages";
import {NumberTextPipe} from "../../pips/number-text.pipe";
import {AccordionModule} from "primeng/accordion";
import {SharedModule} from "primeng/api";
import {SafeHtmlPipePipe} from "../../pips/safe-html-pipe.pipe";

@Component({
    selector: 'app-success-story-page',
    standalone: true,
    imports: [
        SuccessStoryComponent,
        PerformanceSectionComponent,
        CommonModule,
        NumberTextPipe,
        AccordionModule,
        SharedModule,
        SafeHtmlPipePipe
    ],
    templateUrl: './success-story-page.component.html',
    styleUrl: './success-story-page.component.css'
})
export class SuccessStoryPageComponent extends TemplateComponent implements OnInit {

    pageUID: string;
    pageColor: string = "#0245BC";
    pageName: string = "گوشی شاپ";
    imagePath: string = "assets/images/gooshiShop2.png";
    indexList = [];
    page: Pages = new Pages();
    dashboardInf: any;

    @HostListener('body:scroll', ['$event']) // for window scroll events
    onScroll(event) {
        let scrollTop = document.body.scrollTop;
        let windowHeight = window.innerHeight;
        let temp = false;
        let i=0;
        for (let elm of this.indexList) {
            let elmTop = document.getElementById(elm.id).offsetTop;
            let elmTopNext = i<this.indexList.length-1 ? document.getElementById(this.indexList[i+1].id).offsetTop : elmTop;
            if (elmTop > scrollTop && elmTop < scrollTop + windowHeight && !temp) {
                temp = true;
                document.getElementById("li_" + elm.id).classList.add("selected")
            } else if ( elmTopNext > scrollTop + windowHeight && !temp) {
                temp = true;
                document.getElementById("li_" + elm.id).classList.add("selected")
            } else {
                document.getElementById("li_" + elm.id).classList.remove("selected")
            }
            i++;
        }
    }

    ngOnInit() {
        document.body.scrollTop = 0;
        this.pageUID = this.activeRoute.snapshot.paramMap.get("pageUid");
        setTimeout(() => {
            this.loadPage();
        }, 100)

        setTimeout(() => {
            try {
                this.dashboardInf = JSON.parse(this.global.getMainData()['dashboard']['data']);
            } catch (e) {
            }

        }, 500)


    }

    goToSuccessList() {
        this.route.navigate(["/stories"])
    }

    getSectionIndex() {

        var elm = document.querySelectorAll<HTMLElement>(".section-title");
        elm.forEach((h2elm) => {
            let temp = {id: h2elm.id, value: h2elm.innerText}
            this.indexList.push(temp);
        })
    }

    goToFregment(id: string) {
        if (document.getElementById(id)) {
            var headerOffset = 80;
            if(window.innerWidth >768)
                headerOffset=70;
            var elementPosition = document.getElementById(id).offsetTop;
            var offsetPosition = elementPosition  - headerOffset;

            document.body.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });

            document.getElementById("li_" + id).classList.add("selected");
            for (let elm of this.indexList) {
                if (elm.id != id) {
                    document.getElementById("li_" + elm.id).classList.remove("selected")
                }
            }


        }

    }

    toggelSideIndex(sInx: HTMLDivElement) {
        if (sInx.classList.contains("hidden")) {
            sInx.classList.remove("hidden");
        } else {
            sInx.classList.add("hidden");
        }

    }

    loadPage() {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/site/get_page?" +
            "uid=" + this.pageUID+
            "&type=SUCCESS_STORY"
        );
        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    this.page = res["entity"];
                    // console.log(this.attributFilterList);
                    let temp = "";
                    for (let tag of this.page.tags) {
                        temp += tag + ",";
                    }
                    this.titleService.setTitle(this.page.name);
                    this.meta.addTag({name: 'keywords', content: temp}, true);
                    this.meta.addTag({name: 'description', content: this.page.summary}, true);

                } else if (res["status"] == 400) {
                    this.route.navigate(['/'])
                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete: () => {
                this.global.progressBar = false;
                setTimeout(() => {
                    this.getSectionIndex();
                }, 200)

            }
        });
    }


    goToDashboard() {
        setTimeout(() => {
            window.open(this.dashboardInf['loginUrl']);
        }, 200)
    }

    pageClick(event: MouseEvent, sInx: HTMLDivElement) {
        let temp: boolean = false;
        // @ts-ignore
        for (let childNode of document.getElementById('side-index').childNodes) {
            if (childNode == event.target) {
                temp = true;
                break;
            }
            for (let childNode1 of childNode.childNodes) {
                if (childNode1 == event.target) {
                    temp = true;
                    break;
                }
                for (let childNode2 of childNode1.childNodes) {
                    if (childNode2 == event.target) {
                        temp = true;
                        break;
                    }
                }
            }

        }
        if (!temp)
            sInx.classList.add("hidden");
    }
}
